/**
 * VUEX module for authentication and permissions
 * @author      Jeff Adams <jeff@tinyfly.com>
 * @copyright   Traxo, Inc. 2018
 */

import permissions from '@config/roles-and-permissions.yml';

function getPermissionRoles(permission) {
  const roles = permissions[permission];
  if (roles === undefined) {
    throw new Error(`${permission} is not a valid permission`);
  }
  return roles;
}

export const state = {};

export const getters = {
  /**
   * Checks a given permission and determines if the user can access a resource
   * @param {String} permission - pre-defined permission required to access the resource (e.g. 'browse-emails')
   * @returns {Boolean}
   */
  can: (state, getters, rootState, rootGetters) => (permission) => {
    // if we don't have a permission param in then we can assume whatever
    // we're checking isn't protected
    if (!permission) {
      return true;
    }

    let rolesForPermission;
    try {
      rolesForPermission = getPermissionRoles(permission);
    } catch (err) {
      void err;
    }

    // check the user roles against the roles allowed for a specific permission
    let hasPermission = false;
    const userRoles = rootGetters['me/userRolesForTeam'];
    if (userRoles && Array.isArray(userRoles)) {
      hasPermission = userRoles.some((role) => rolesForPermission.indexOf(role) !== -1);
    }

    return hasPermission;
  },
};
